<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-25 10:32:01
 * @LastEditors: geory
 * @LastEditTime: 2024-07-15 10:12:01
-->
<template>
  <div @contextmenu.prevent.stop>
    <div class="cover" :style="{'width':pageWidth,'height':pageHeight}" @click="hideMenu">
      <div class="container" :style="{'top':menuY+'px','left':menuX+'px'}">
        <!-- <div class="munucell borderNone" @click="edit">编辑</div>
        <div class="munucell" @click="remove">删除</div> -->
        <div v-for="(cell,idx) in cellList" :key="'menuItem'+idx" :class="idx==0?'munucell borderNone':'munucell'"
          @click="cellClick(idx)">{{cell.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  //话术右键菜单
  export default {
    props: ['menuY', 'menuX', 'cellList'],
    data() {
      return {
        pageHeight: document.documentElement.clientHeight + 'px',
        pageWidth: document.documentElement.clientWidth + 'px',
      }
    },
    components: {

    },
    computed: {

    },
    methods: {
      cellClick(idx) {
        this.$emit('cellClick', idx);
        this.hideMenu();
      },
      edit() {
        this.$emit('edit');
        this.hideMenu();
      },
      remove() {
        this.$emit('remove');
        this.hideMenu();
      },
      hideMenu() {
        this.$emit('hideMenu')
      }
    },
    async mounted() {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cover {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
  }

  .container {
    width: 96px;
    background-color: #F0F0F0;
    border: 1px solid #E5E5E5;
    position: absolute;
    z-index: 99999;
    border-radius: 8px;
  }

  .munucell {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #E5E5E5;
    color: #3C3C3C;
  }

  .borderNone {
    border: none;
  }
</style>